import * as at from "../action-types";

const initialState = {
  visible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case at.TOGGLE_SIDEBAR:
      return {
        ...state,
        visible: !state.visible,
      };
    default:
      return state;
  }
};
